import { useAppSelector } from 'src/store/hooks'

export const useIsLoggedIn = () =>
    useAppSelector((state) => state.user.data?.token?.access_token !== undefined)
